export const ENTITY_ITEMS = [
    { name: 'Wing UK', label: 'Wing UK', value: 'Wing UK' },
    { name: 'Mobi NI', label: 'Mobi NI', value: 'Mobi NI' },
    { name: 'Wing US', label: 'Wing US', value: 'Wing US' },
    { name: 'Mobi Market B.V', label: 'Mobi Market B.V', value: 'Mobi Market B.V' },
    { name: 'Other', label: 'Other', value: 'Other' },
];